import { useEffect, useState } from 'react';
import { Trash, CirclePlus, Ruler } from 'lucide-react';
import { Box } from 'rizzui/box';
import AppButton from '../../../../components/AppButton/AppButton';
import { searchProduct, updateProduct as updateProductUnit } from '../../../../constant/Constant';
import { HitApi } from '../../../../Api/ApiHit';
import { getSelectedUnit } from '../../../../storage/Storage';
import SearchableSelectNonRedux from '../../../../components/AppSelect/SearchableSelectNonRedux';
import { searchGeneralMasterData } from '../../../../utils/utils';
import toast from 'react-hot-toast';
import { unitOptions } from '../../../../constant/Options';
import SearchableSelect from '../../../../components/AppSelect/SearchableSelect';
import { useSelector } from 'react-redux';

function ServiceSteps({
    steps,
    isLoading,
    addStep,
    removeStep,
    updateStep,
    addProductToStep,
    removeProductFromStep,
    updateProduct,
    editMode = false,
    editData = null,
    stepError = '' // Added stepError prop
}) {
    const [brandOptions, setBrandOptions] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [productTypeOptions, setProductTypeOptions] = useState([]);
    const ApiReducer = useSelector((state) => state.ApiReducer);






    console.log("productTypeOptions", productTypeOptions);

    const [loading, setLoading] = useState({
        brands: false,
        productTypes: false,
        products: false
    });
    const [initialDataLoaded, setInitialDataLoaded] = useState(false);

    useEffect(() => {
        // Load initial data without search terms
        loadInitialData();
    }, []);

    // Enhanced edit mode data loading
    useEffect(() => {
        if (editMode && editData?.steps && initialDataLoaded) {
            // Add a small delay to ensure all async operations complete
            const timer = setTimeout(() => {
                addProductsFromEditData();
                preloadProductsForEdit();
                validateAndSetEditValues();
            }, 200);

            return () => clearTimeout(timer);
        }
    }, [editMode, editData, initialDataLoaded]);

    // Function to handle wheel event on number inputs
    const handleWheel = (e) => {
        e.target.blur();
    };

    // Function to check if a specific field has an error
    const hasFieldError = (stepId, field) => {
        if (!stepError) return false;

        // Find the step number for this stepId
        const step = steps.find(s => s.id === stepId);
        if (!step) return false;

        const stepNumber = step.step;

        // Check if the error message contains this step and field
        if (field === 'stepName') {
            return stepError.includes(`Step ${stepNumber}: Step Name is required`);
        } else if (field === 'service_time') {
            return stepError.includes(`Step ${stepNumber}: Service Time is required`) ||
                stepError.includes(`Step ${stepNumber}: Service Time must be a valid number greater than 0`);
        }

        return false;
    };

    // Function to get field-specific error message
    const getFieldErrorMessage = (stepId, field) => {
        if (!hasFieldError(stepId, field)) return '';

        const step = steps.find(s => s.id === stepId);
        if (!step) return '';

        const stepNumber = step.step;

        if (field === 'stepName') {
            return 'Step Name is required';
        } else if (field === 'service_time') {
            if (stepError.includes(`Step ${stepNumber}: Service Time must be a valid number greater than 0`)) {
                return 'Service Time must be a valid number greater than 0';
            } else {
                return 'Service Time is required';
            }
        }

        return '';
    };

    // New function to validate and set edit values
    const validateAndSetEditValues = () => {
        if (!editMode || !editData?.steps) return;

        console.log("Validating and setting edit values...");
        console.log("Available brand options:", brandOptions);
        console.log("Available product type options:", productTypeOptions);

        editData.steps.forEach((step, stepIndex) => {
            step.products.forEach((product, productIndex) => {
                let brand = "";
                let productType = "";

                if (typeof product.product === 'object' && product.product?.brand) {
                    brand = product.product.brand;
                    productType = product.product.productType;
                } else {
                    brand = product.brand;
                    productType = product.productType;
                }

                // Check if the brand exists in brandOptions
                const brandExists = brandOptions.some(option =>
                    option.value === brand || option.label === brand
                );

                // Check if the product type exists in productTypeOptions  
                const productTypeExists = productTypeOptions.some(option =>
                    option.value === productType || option.label === productType
                );

                console.log(`Step ${stepIndex + 1}, Product ${productIndex + 1}:`, {
                    brand,
                    productType,
                    brandExists,
                    productTypeExists
                });

                // If brand or productType don't exist in options, add them
                if (brand && !brandExists) {
                    console.log(`Adding missing brand option: ${brand}`);
                    setBrandOptions(prev => [...prev, {
                        value: brand,
                        label: brand
                    }]);
                }

                if (productType && !productTypeExists) {
                    console.log(`Adding missing product type option: ${productType}`);
                    setProductTypeOptions(prev => [...prev, {
                        value: productType,
                        label: productType
                    }]);
                }
            });
        });
    };

    // Load initial data for brands and product types
    const loadInitialData = async () => {
        try {
            await Promise.all([
                getBrandFromGeneralMaster(""),
                getProductTypeFromGeneralMaster("")
            ]);
            setInitialDataLoaded(true);
            console.log("Initial data loaded successfully");
        } catch (error) {
            console.error("Error loading initial data:", error);
            setInitialDataLoaded(true); // Set to true even on error to prevent infinite loading
        }
    };

    const getBrandFromGeneralMaster = async (searchValue = "") => {
        try {
            setLoading(prev => ({ ...prev, brands: true }));

            const result = await searchGeneralMasterData("Brand", searchValue, 500);

            console.log("resultresult",result);
            

            if (result.success && result.data) {
                // Ensure proper option format
                const formattedOptions = result.data.map(item => ({
                    value: item.value || item.name || item,
                    label: item.label || item.name || item
                }));

                setBrandOptions(prevOptions => {
                    // Merge with existing options, avoiding duplicates
                    const existingValues = prevOptions.map(opt => opt.value);
                    const newOptions = formattedOptions.filter(opt => !existingValues.includes(opt.value));
                    const mergedOptions = [...prevOptions, ...newOptions];

                    console.log("Updated brand options:", mergedOptions);
                    return mergedOptions;
                });
            } else {
                console.error("Error loading brands:", result.error);
                if (searchValue === "") {
                    setBrandOptions([]);
                }
            }
        } catch (error) {
            console.error("Unexpected error loading brands:", error);
            if (searchValue === "") {
                setBrandOptions([]);
            }
        } finally {
            setLoading(prev => ({ ...prev, brands: false }));
        }
    };

    const getProductTypeFromGeneralMaster = async (searchValue = "") => {
        try {
            setLoading(prev => ({ ...prev, productTypes: true }));

            const result = await searchGeneralMasterData("ProductType", searchValue, 500);

            if (result.success && result.data) {
                // Ensure proper option format
                const formattedOptions = result.data.map(item => ({
                    value: item.value || item.name || item,
                    label: item.label || item.name || item
                }));

                setProductTypeOptions(prevOptions => {
                    // Merge with existing options, avoiding duplicates
                    const existingValues = prevOptions.map(opt => opt.value);
                    const newOptions = formattedOptions.filter(opt => !existingValues.includes(opt.value));
                    const mergedOptions = [...prevOptions, ...newOptions];

                    console.log("Updated product type options:", mergedOptions);
                    return mergedOptions;
                });
            } else {
                console.error("Error loading product types:", result.error);
                if (searchValue === "") {
                    setProductTypeOptions([]);
                }
            }
        } catch (error) {
            console.error("Unexpected error loading product types:", error);
            if (searchValue === "") {
                setProductTypeOptions([]);
            }
        } finally {
            setLoading(prev => ({ ...prev, productTypes: false }));
        }
    };

    const getProductFiltered = async (brand, productType) => {
        if (!brand || !productType) {
            console.log("Brand or product type missing, skipping product fetch");
            return;
        }

        try {
            setLoading(prev => ({ ...prev, products: true }));

            const json = {
                page: 1,
                limit: 100,
                search: {
                    brand: brand,
                    productType: productType,
                    unitIds: getSelectedUnit()?._id
                }
            };

            const response = await HitApi(json, searchProduct);


            console.log("response", response);


            if (response?.data?.docs?.length) {
                const options = response.data?.docs?.map((item) => ({
                    label: item.productName || item.name || `Product ${item._id}`,
                    value: item._id,
                    name: item.productName || item.name,
                    brand: item.brand,
                    productType: item.productType,
                    unit: item.unit,
                    costPrice: item.costPrice,
                    sellPrice: item.sellPrice,
                    inStockQuantity: item.inStockQuantity,
                    netQuantity: item.netQuantity // Added netQuantity
                }));

                setProductOptions(prevOptions => {
                    const existingValues = prevOptions.map(opt => opt.value);
                    const newOptions = options.filter(opt => !existingValues.includes(opt.value));
                    return [...prevOptions, ...newOptions];
                });
            }
        } catch (error) {
            console.error("Error fetching filtered products:", error);
        } finally {
            setLoading(prev => ({ ...prev, products: false }));
        }
    };

    const addProductsFromEditData = () => {
        if (!editMode || !editData?.steps) return;

        const productsToAdd = [];

        editData.steps.forEach(step => {
            step.products.forEach(product => {
                if (typeof product.product === 'object' && product.product?._id) {
                    const productObj = product.product;
                    productsToAdd.push({
                        label: productObj.productName || productObj.name || `Product ${productObj._id}`,
                        value: productObj._id,
                        name: productObj.productName || productObj.name,
                        brand: productObj.brand,
                        productType: productObj.productType,
                        unit: productObj.unit,
                        costPrice: productObj.costPrice,
                        sellPrice: productObj.sellPrice,
                        inStockQuantity: productObj.inStockQuantity || 0,
                        netQuantity: productObj.netQuantity // Added netQuantity
                    });
                }
            });
        });

        if (productsToAdd.length > 0) {
            setProductOptions(prevOptions => {
                const existingValues = prevOptions.map(opt => opt.value);
                const newOptions = productsToAdd.filter(opt => !existingValues.includes(opt.value));
                return [...prevOptions, ...newOptions];
            });
            console.log("Added products from edit data:", productsToAdd);
        }
    };

    const preloadProductsForEdit = () => {
        if (!editMode || !editData?.steps) return;

        editData.steps.forEach(step => {
            step.products.forEach(product => {
                let brand = "";
                let productType = "";

                if (typeof product.product === 'object' && product.product?.brand) {
                    brand = product.product.brand;
                    productType = product.product.productType;
                } else {
                    brand = product.brand;
                    productType = product.productType;
                }

                if (brand && productType) {
                    console.log(`Preloading products for brand: ${brand}, productType: ${productType}`);
                    getProductFiltered(brand, productType);
                }
            });
        });
    };

    const getProductDetails = (productId) => {
        return productOptions.find((p) => p.value === productId) || {};
    };

    const handleProductUpdate = (stepId, productId, field, value) => {
        updateProduct(stepId, productId, field, value);

        if (field === 'brand' || field === 'productType') {
            const currentStep = steps.find(step => step.id === stepId);
            const currentProduct = currentStep?.products.find(p => p.id === productId);

            if (currentProduct) {
                const brand = field === 'brand' ? value : currentProduct.brand;
                const productType = field === 'productType' ? value : currentProduct.productType;

                if (brand && productType) {
                    getProductFiltered(brand, productType);
                }
            }
        }
    };

    // Search handlers for brand and product type with debouncing
    const handleBrandSearch = async (searchTerm) => {
        await getBrandFromGeneralMaster(searchTerm);
    };

    const handleProductTypeSearch = async (searchTerm) => {
        await getProductTypeFromGeneralMaster(searchTerm);
    };

    // Function to calculate cost for quantity
    const calculateCost = (quantity, costPrice, netQuantity) => {
        if (!quantity || !costPrice || !netQuantity) return 0;
        return (costPrice / netQuantity) * parseFloat(quantity);
    };


    // const handleUnitChange = (id) => {
    //     console.log("id",id);

    //     console.log("ApiReduce----r", ApiReducer);
    //    var json = {
    //         _id :id,
    //         unit :ApiReducer?.apiJson?.unit
    //     }
    //     console.log("json",json);

    //     HitApi(json ,updateProductUnit).then((res)=>{
    //         console.log("res",res);
    //         if(res?.message === "Product updated successfully"){

    //             toast.success("Product Unit Updated successfully ")
    //         }

    //     })

    // }


    const handleUnitChange = (productId) => {
        console.log("productId", productId);
        console.log("ApiReducer", ApiReducer);

        const json = {
            _id: productId,
            unit: ApiReducer?.apiJson?.unit
        };

        console.log("Sending JSON:", json);

        HitApi(json, updateProductUnit).then((res) => {

            if (res?.statusCode === 200) {
                toast.success("Product Unit Updated successfully");

                setProductOptions(prevOptions => {
                    return prevOptions.map(option => {
                        if (option.value === productId) {
                            return {
                                ...option,
                                unit: ApiReducer?.apiJson?.unit
                            };
                        }
                        return option;
                    });
                });
            }
        }).catch(err => {
            console.error("Error updating unit:", err);
            toast.error("Failed to update product unit");
        });
    };

    return (
        <Box className="bg-white p-8 border rounded-xl mt-5">
            <div className="text-lg font-medium my-5 flex justify-between items-center">
                <span>Service Steps</span>
            </div>
            {steps.length > 0 && (
                <div className="space-y-6">
                    {steps.map((step, index) => (
                        <div key={step.id} className="border-2 border-gray-200 rounded-lg p-6 bg-gray-50">
                            <div className="flex justify-between items-center mb-4">
                                <h4 className="font-medium text-gray-700 text-lg">Step {step.step}</h4>
                                {steps.length > 1 && (
                                    <button
                                        onClick={() => removeStep(step.id)}
                                        className="text-red-500 hover:text-red-700 p-1 rounded"
                                        title="Remove Step"
                                    >
                                        <Trash size={18} />
                                    </button>
                                )}
                            </div>

                            {/* Step Name & Time */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Step Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={step.stepName}
                                        onChange={(e) => updateStep(step.id, 'stepName', e.target.value)}
                                        placeholder="Enter step name"
                                        className={`w-full px-3 py-2 border border-gray-300 rounded-md `}
                                    />
                                    {hasFieldError(step.id, 'stepName') && (
                                        <p className="text-red-500 text-xs mt-1">
                                            {getFieldErrorMessage(step.id, 'stepName')}
                                        </p>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Service Time (minutes) <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="1"
                                        step="1"
                                        value={step.service_time}
                                        onChange={(e) => updateStep(step.id, 'service_time', e.target.value)}
                                        onWheel={handleWheel}
                                        placeholder="Enter time in minutes (e.g., 10, 20, 30)"
                                        className={`w-full px-3 py-2 border border-gray-300 rounded-md `}
                                    />
                                    {hasFieldError(step.id, 'service_time') && (
                                        <p className="text-red-500 text-xs mt-1">
                                            {getFieldErrorMessage(step.id, 'service_time')}
                                        </p>
                                    )}
                                    <p className="text-xs text-gray-500 mt-1">
                                        Enter time in minutes only (e.g., 10, 20, 30, 45, 60)
                                    </p>
                                </div>
                            </div>

                            {/* Products Section */}
                            <div className="mt-4">
                                <div className="flex justify-between items-center mb-3">
                                    <h5 className="font-medium text-gray-600">Products for this step</h5>
                                </div>

                                <div className="space-y-3">
                                    {step.products.length === 0 ? (
                                        <div className="text-sm text-gray-400 italic">
                                            No products added for this step.
                                        </div>
                                    ) : (
                                        step.products.map((product, productIndex) => {
                                            const productDetails = getProductDetails(product.product);

                                            return (
                                                <div key={product.id} className="bg-white p-4 rounded-lg border">
                                                    <div className="flex justify-between items-center mb-2">
                                                        <span className="text-sm font-medium text-gray-600">
                                                            Product {productIndex + 1}
                                                        </span>
                                                        <button
                                                            onClick={() => removeProductFromStep(step.id, product.id)}
                                                            className="text-red-500 hover:text-red-700 p-1"
                                                            title="Remove Product"
                                                        >
                                                            <Trash size={14} />
                                                        </button>
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                                                        {/* Brand Selection */}
                                                        <div>
                                                            <SearchableSelectNonRedux
                                                                title="Brand"
                                                                name={`brand-${step.id}-${product.id}`}
                                                                options={brandOptions}
                                                                value={product.brand}
                                                                onSelect={(value) => handleProductUpdate(step.id, product.id, 'brand', value)}
                                                                placeholder="Select brand"
                                                                onSearch={handleBrandSearch}
                                                                loading={loading.brands}
                                                            />
                                                        </div>

                                                        {/* Product Type Selection */}
                                                        <div>
                                                            <SearchableSelectNonRedux
                                                                title="Product Type"
                                                                name={`productType-${step.id}-${product.id}`}
                                                                options={productTypeOptions}
                                                                value={product.productType}
                                                                onSelect={(value) => handleProductUpdate(step.id, product.id, 'productType', value)}
                                                                placeholder="Select product type"
                                                                onSearch={handleProductTypeSearch}
                                                                loading={loading.productTypes}
                                                            />
                                                        </div>

                                                        <div>
                                                            <SearchableSelectNonRedux
                                                                title="Product"
                                                                name={`product-${step.id}-${product.id}`}
                                                                options={(() => {
                                                                    const filteredOptions = productOptions
                                                                        .filter(prod =>
                                                                            (!product.brand || prod.brand === product.brand) &&
                                                                            (!product.productType || prod.productType === product.productType)
                                                                        )
                                                                        .map(prod => ({
                                                                            value: prod.value,
                                                                            label: prod.label || prod.name || prod.productName || `Product ${prod.value}`,
                                                                            brand: prod.brand,
                                                                            productType: prod.productType,
                                                                            unit: prod.unit,
                                                                            costPrice: prod.costPrice,
                                                                            sellPrice: prod.sellPrice,
                                                                            inStockQuantity: prod.inStockQuantity,
                                                                            netQuantity: prod.netQuantity
                                                                        }));

                                                                    console.log('Filtered Product Options:', filteredOptions);
                                                                    console.log('Current Product Value:', product.product);
                                                                    return filteredOptions;
                                                                })()}
                                                                value={product.product}
                                                                onSelect={(value) => handleProductUpdate(step.id, product.id, 'product', value)}
                                                                placeholder={
                                                                    !product.brand || !product.productType
                                                                        ? "Select brand & type first"
                                                                        : "Select product"
                                                                }
                                                                disabled={!product.brand || !product.productType}
                                                                loading={loading.products}
                                                            />
                                                        </div>

                                                        {/* Quantity Input */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                                Quantity
                                                                {productDetails?.unit && ` (${productDetails.unit})`}
                                                                <span className="text-red-500">*</span>
                                                            </label>
                                                            <input
                                                                type="number"
                                                                min="1"
                                                                step="0.1"
                                                                value={product.quantity}
                                                                onChange={(e) =>
                                                                    handleProductUpdate(step.id, product.id, 'quantity', e.target.value)
                                                                }
                                                                onWheel={handleWheel}
                                                                placeholder={`Enter quantity${productDetails?.unit ? ` in ${productDetails.unit}` : ''}`}
                                                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            />

                                                            {/* Cost Display */}
                                                            {product.quantity && productDetails?.costPrice && productDetails?.netQuantity && (
                                                                <div className="mt-2 p-2 bg-gray-50 rounded-md border">
                                                                    <div className="flex justify-between items-center text-sm">
                                                                        <span className="text-gray-600">Cost for {product.quantity}{productDetails?.unit}:</span>
                                                                        <span className="font-medium text-gray-800">
                                                                            ₹{calculateCost(product.quantity, productDetails.costPrice, productDetails.netQuantity).toFixed(2)}
                                                                        </span>
                                                                    </div>
                                                                    <div className="flex justify-between items-center text-xs text-gray-500 mt-1 ">
                                                                        <span>Rate: ₹{(productDetails.costPrice / productDetails.netQuantity).toFixed(2)} per {productDetails?.unit}</span>

                                                                    </div>
                                                                    <div>
                                                                        <div className='text-base text-blue-600 font-semibold'>
                                                                            Change unit
                                                                        </div>
                                                                        <SearchableSelect
                                                                            title="Select Unit"
                                                                            name="unit"
                                                                            options={unitOptions}
                                                                            placeholder="Select Unit"
                                                                            icon={<Ruler size={18} />}
                                                                            specification="Choose the unit of measurement for this product"
                                                                            defaultValue={productDetails?.unit }

                                                                        />
                                                                        <AppButton buttontext={"Change Unit"} onClick={() => handleUnitChange(product?.product)} />
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {console.log('productDetails', productDetails)
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>

                                {/* Add Product Button */}
                                <div className="flex mt-5 justify-end">
                                    <AppButton
                                        buttontext={"Add Product"}
                                        icon={CirclePlus}
                                        onClick={() => addProductToStep(step.id)}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Add Step Button */}
            <div className="text-lg font-medium mt-5 flex justify-end items-center">
                <AppButton
                    buttontext="Add Step"
                    onClick={addStep}
                    disabled={isLoading}
                    icon={CirclePlus}
                />
            </div>

            {/* Empty State */}
            {steps.length === 0 && (
                <div className="text-center py-8 text-gray-500">
                    <p>No steps added yet. Click "Add Step" to create your first step.</p>
                </div>
            )}
        </Box>
    );
}
export default ServiceSteps;